import { useMutation } from '@apollo/client';
import { CREATE_PICKUP_ROUTE_HISTORY } from '../graphql/mutations/createPickupRouteHistory';
import { CreatePickupRouteHistoryInput, CreatePickupRouteHistoryResponse } from '../graphql/types/PickupRouteHistoryTypes';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export const useCreatePickupRouteHistory = () => {
  const { t } = useTranslation();
  const [createPickupRouteHistory, { loading, error }] = useMutation<
    CreatePickupRouteHistoryResponse,
    { input: CreatePickupRouteHistoryInput }
  >(CREATE_PICKUP_ROUTE_HISTORY);

  const createHistory = async (input: CreatePickupRouteHistoryInput) => {
    try {
      const response = await createPickupRouteHistory({
        variables: { input },
      });
      
      if (response.data?.createPickupRouteHistory) {
      
        message.success(t('pickup.pickupTask.pageDetails.messages.createPickupRouteHistorySuccessfully', {count: response.data.createPickupRouteHistory.length}) || '');
        return response.data.createPickupRouteHistory;
      } else {
        throw new Error(t('pickup.pickupTask.pageDetails.messages.failedToCreatePickupRouteHistory') || '');
      }
    } catch (err: any) {
      console.error('Error creating pickup route history:', err);
      const errorMessage = err.message || t('pickup.pickupTask.pageDetails.messages.failedToCreatePickupRouteHistory') || '';
      message.error(errorMessage);
      throw err;
    }
  };

  return {
    createHistory,
    loading,
    error,
  };
};
